import { render, staticRenderFns } from "./BillingTermsSettings.vue?vue&type=template&id=6c1b77c0"
import script from "./BillingTermsSettings.vue?vue&type=script&lang=js"
export * from "./BillingTermsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports